import React, { useEffect, useState } from 'react';
import styles from './TrafficLight.module.css';
import EventApi from '../../services/EventApi'; 
import moment from 'moment';
import { useToast } from "../../context/ToastContext"; 
import { useTranslation } from 'react-i18next';

interface Event {
  eventDate: string; 
  status: boolean;
  id: string
}

interface ApiResponse {
  success: boolean;
  data: Event[];
}


interface TrafficLightProps {
  deviceId: number; 
  dateFilter: Date
}

const TrafficLight: React.FC<TrafficLightProps> = ({ deviceId, dateFilter }): JSX.Element => {
  const [latestStatus, setLatestStatus] = useState<boolean | null>(null);   
  const { displayToast } = useToast(); 
  const { t: translateMessage } = useTranslation("messages");

  let memoId = ""  

  useEffect(() => { 
    const fetchEvents = async (): Promise<void> => {
      
      try {
        if(deviceId !== 0 ){
          const response: ApiResponse = await EventApi.GetEventsByDeviceId(deviceId, new Date());

          if (response.success && response.data.length > 0) {
            const latestEvent = response.data.reduce<Event>((prev, current) => 
              new Date(prev.eventDate) > new Date(current.eventDate) ? prev : current,
              response.data[0]
            );   

            let dateEvent = new Date(latestEvent.eventDate);   
            let formatedEventDate = moment(dateEvent).subtract(3, 'hours').toDate()  
            let actualDateSubstract = moment().subtract(10, 'seconds').toDate()    

            if(formatedEventDate > actualDateSubstract && memoId !== latestEvent.id) {
              memoId = latestEvent.id 
              setLatestStatus(latestEvent.status); 
            } else {
              setLatestStatus(null);
            }
          } else {
            setLatestStatus(null);
          }
        }   
      } catch (error) {
        console.error('Erro ao buscar eventos:', error);
        displayToast("error", translateMessage("errorSearchEvents"), "", false, 3000); 
        setLatestStatus(null);
      }
    };  

    const validDay = (): void => { 
      let selectedDate = moment(dateFilter).format('YYYY-MM-DD'); 
      let actualDate = new Date().toISOString().split('T')[0];  

      if(selectedDate === actualDate) { 
        fetchEvents()
      }     
    }; 

    const interval = setInterval(validDay, 10000); // busca a cada 10segundos

    return () => clearInterval(interval); // Limpeza no efeito
  }, [deviceId]);
 
  useEffect(() => {   
    const interval = setTimeout(() => {
      setLatestStatus(null)
    }, 5000); 

    return () => clearInterval(interval); // Limpeza no efeito
  }, [latestStatus]);

  const statusStyleBottom = latestStatus === null ? styles.boxTrafic 
    : (latestStatus ? styles.activeGreen : styles.boxTrafic);

  const statusStyle = latestStatus === null ? styles.boxTrafic 
  : (!latestStatus ? styles.inactive : styles.boxTrafic);

  return (    
    <div  className={styles.container}>      
      <div className={`${styles.boxTrafic} ${statusStyle}`}></div>	  	
      <div className={`${styles.boxTrafic} ${statusStyleBottom}`}></div>	   	   	   	
    </div>
  );
}

export default TrafficLight;
